import { render } from "./office-single.vue?vue&type=template&id=de19e2f6&scoped=true"
import script from "./office-single.vue?vue&type=script&lang=js"
export * from "./office-single.vue?vue&type=script&lang=js"

import "./office-single.vue?vue&type=style&index=0&id=de19e2f6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de19e2f6"]])

export default __exports__